"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearFix = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _clearFixMixin = require("../../mixins/clearFixMixin");
/**
 * While traditionally a clearfix was used as a way to
 * [clear layout issues with floated elements](https://css-tricks.com/clearfix-a-lesson-in-web-development-evolution/),
 * this can also be used to manage
 * [margin collapse](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing).
 *
 * @since 8.15.0
 */
var ClearFix = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "ClearFix",
  componentId: "c11n-8-107-0__sc-1tt6y0b-0"
})(["", ""], _clearFixMixin.clearFixMixin);
exports.ClearFix = ClearFix;
ClearFix.displayName = 'ClearFix';

/** @component */